module.exports = __webpack_public_path__ + "img/youtube.77d0e64a.png";